// extracted by mini-css-extract-plugin
module.exports = {"scoreDisplayContainer":"ScoreDisplay_scoreDisplayContainer__5TlPS","heading":"ScoreDisplay_heading__Oufrl","svgDiv":"ScoreDisplay_svgDiv__1UdJ0"};